// eslint-disable-next-line import/prefer-default-export
import { createSelector } from 'reselect';
import { getSelectedBrowseItems } from '../browse-items/selectors';

export const getSet = ({ set }) => set.data;
export const getSetLoadingState = ({ set }) => set.loading;

export const getSelectedSetItems = createSelector(
  getSet,
  getSelectedBrowseItems,
  (set, ids) => (set?.items || [])
    .filter(({ id }) => ids.includes(id)),
);
